module.exports = __webpack_public_path__ + "static/assets/d5f30b86f1c478658db4c41ef453cdbd.gif";